import { Button, Modal } from "react-bootstrap";
import { formatDate } from "../util/format";

const OrderItemSubjects = ({ name, show, setShow, subjects }) => {
    return (
        <Modal size="lg" className="fade" show={show}>
            <Modal.Header>
                <Modal.Title>Motivos de cambios de:  {name}</Modal.Title>
                <Button
                    variant=""
                    className="btn-close"
                    onClick={() => setShow?.(false)}
                >
                </Button>
            </Modal.Header>
            <Modal.Body>
                {subjects?.map((subject) => {
                    return (
                        <div key={`motivo-${subject?.id}`} className="border rounded mb-3 p-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center fw-bold gap-2">
                                    <img src={subject?.user?.imagePath} className="border border-primary rounded-circle" style={{ height: 40, width: 40 }} />
                                    <p className="mb-0">
                                        {subject?.user?.name}
                                        <br />
                                        {subject?.user?.documentNumber}
                                    </p>
                                </div>
                                <p className="mb-0 fw-bold">
                                    {formatDate(subject?.created_at)}
                                </p>
                            </div>
                            <p className="mb-0">
                                {subject?.description}
                            </p>
                        </div>
                    )
                })}
            </Modal.Body>
        </Modal>
    )
}

export default OrderItemSubjects;